<template>
  <div style="display: flex">
    <div style="font-weight: bold; font-size: 20px">
      <v-icon class="mr-3">mdi-volume-high</v-icon>
      Audio
    </div>
    <v-spacer />
    <HelpButton mdx-name="AudioConfigure" />
  </div>
  <v-divider class="mt-3" />
  <div class="config-page-body">
    <!-- <v-card
      flat
      style="margin-top: 40px; margin-bottom: 20px"
      class="pa-6">
      <div></div>
      <v-card-subtitle style="text-align: center">
        Global Audio Controls
      </v-card-subtitle>
      <v-divider class="mt-3" />
      <v-slider
        prepend-icon="mdi-volume-high"
        style="width: 100%; display: inline"
        class="align-center"
        hide-details
        :max="100"
        :min="0"
        v-model="frameVols['.VolumeControl.Ventuz.Volume']"
        :label="'All Volume (Excludes SDI)'"></v-slider>
    </v-card> -->
    <v-card
      flat
      style="margin-top: 40px; margin-bottom: 20px"
      class="pa-6">
      <div></div>
      <v-card-subtitle style="text-align: center">
        Frame Audio Controls
      </v-card-subtitle>
      <v-divider class="mt-3" />
      <v-slider
        v-for="frame in deluge.frames"
        prepend-icon="mdi-volume-high"
        style="width: 100%; display: inline"
        class="align-center"
        hide-details
        :max="100"
        :min="0"
        v-model="frameVols[`.Frame_${frame.id}_P.Volume`]"
        :label="frame.name"></v-slider>
    </v-card>
    <v-card
      flat
      style="margin-top: 40px; margin-bottom: 20px"
      class="pa-6">
      <div></div>
      <v-card-subtitle style="text-align: center">
        SDI Audio Controls
      </v-card-subtitle>
      <v-divider class="mt-3" />
      <v-slider
        v-for="i in 8"
        prepend-icon="mdi-volume-high"
        style="width: 100%; display: inline"
        class="align-center"
        hide-details
        :max="100"
        :min="0"
        v-model="frameVols[`.VolumeControl.VideoFeed${i}.Volume`]"
        :label="`Video Input ${i}`"></v-slider>
    </v-card>
  </div>
</template>
<script setup>
import { deluge, deluge_sock } from '@/stores/deluge.js';
import { $http } from '../../stores/http.js';
import { ref, reactive, watch, onMounted } from 'vue';
import HelpButton from '../Help-Hints/HelpButton.vue';
const loading = ref(false);
const frameVols = reactive({
  '.Frame_1_B.Volume': 100,
  '.Frame_1_P.Volume': 100,
  '.Frame_2_B.Volume': 100,
  '.Frame_2_P.Volume': 100,
  '.Frame_3_B.Volume': 100,
  '.Frame_3_P.Volume': 100,
  '.Frame_4_B.Volume': 100,
  '.Frame_4_P.Volume': 100,
  '.Frame_5_B.Volume': 100,
  '.Frame_5_P.Volume': 100,
  '.Frame_6_B.Volume': 100,
  '.Frame_6_P.Volume': 100,
  '.VolumeControl.Ventuz.Volume': 100,
  '.VolumeControl.VideoFeed1.Volume': 100,
  '.VolumeControl.VideoFeed2.Volume': 100,
  '.VolumeControl.VideoFeed3.Volume': 100,
  '.VolumeControl.VideoFeed4.Volume': 100,
  '.VolumeControl.VideoFeed5.Volume': 100,
  '.VolumeControl.VideoFeed6.Volume': 100,
  '.VolumeControl.VideoFeed7.Volume': 100,
  '.VolumeControl.VideoFeed8.Volume': 100,
});
let intervalTask = null;
onMounted(() => {
  Object.assign(frameVols, deluge.volume_svars);
  intervalTask = setInterval(updateVolume, 100);
});

let changeDetected = false;
watch(
  frameVols,
  () => {
    changeDetected = true;
  },
  { deep: true }
);
const updateVolume = () => {
  if (!changeDetected) {
    return false;
  } else {
    changeDetected = false;
  }
  for (let i = 1; i <= 6; i++) {
    frameVols[`.Frame_${i}_B.Volume`] = frameVols[`.Frame_${i}_P.Volume`];
  }
  if (window.self !== window.top) {
    parent.postMessage(
      {
        deluge_cmd: {
          cmd: 'STORE',
          key: 'volume_svars',
          publish: true,
          persist: true,
          keys: [],
          val: frameVols,
        },
      },
      '*'
    );
  } else {
    deluge_sock.value.send(
      new Blob([
        JSON.stringify({
          cmd: 'STORE',
          key: 'volume_svars',
          publish: true,
          persist: true,
          keys: [],
          val: frameVols,
        }),
      ])
    );
  }
};
</script>

<style scoped>
@import './config.css';
</style>
